// Money formatting shared by the sim (log/post text) and the UI. Pure: no DOM.
// Amounts are WUSD; the symbol comes from config so the currency can be renamed without code edits.

import { CURRENCY } from "./config/content";

const SYM = CURRENCY.main.symbol;

/** WUSD amount: W$12, W$4,500, W$40.0k, W$1.25M. */
export function money(n: number): string {
  if (!Number.isFinite(n)) return `${SYM}0`;
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1e9) return `${sign}${SYM}${(abs / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `${sign}${SYM}${(abs / 1e6).toFixed(2)}M`;
  if (abs >= 1e4) return `${sign}${SYM}${(abs / 1e3).toFixed(1)}k`;
  return `${sign}${SYM}${abs.toLocaleString("en-US", { maximumFractionDigits: abs < 100 ? 2 : 0 })}`;
}

/** Short WUSD for chatter and signs: W$950, W$12k, W$1.2M. */
export function moneyShort(n: number): string {
  if (n >= 1e6) return `${SYM}${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${SYM}${Math.round(n / 1e3)}k`;
  return `${SYM}${Math.round(n)}`;
}

/** Token unit prices (often tiny): 3 significant digits. */
export function unitPrice(n: number): string {
  if (!(n > 0)) return `${SYM}0`;
  if (n >= 1) return `${SYM}${n.toFixed(2)}`;
  return `${SYM}${n.toPrecision(3)}`;
}

/** Gas amounts: 0.4 DGN, 12 DGN. */
export function gas(n: number): string {
  const v = Math.abs(n) >= 100 ? Math.round(n).toLocaleString("en-US") : Number(n.toFixed(Math.abs(n) < 10 ? 2 : 1)).toString();
  return `${v} ${CURRENCY.gas.code}`;
}
